module.exports = __webpack_public_path__ + "static/media/Oval@3x.91f63730.png";